





































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BottomWrapper } from '../BottomWrapper.vue';
import waiting from '@/components/loading/waiting';
import {
  isEmailValid,
  isPhoneValid,
  stringLengthWithoutSpace,
} from '@/common/utils';
// import { stepEnum } from '@/views/Chatroom/model';
import * as PleasedApi from '@/common/api/api.pleased';
import { PleasedUserInfo, VisitorInfoFilled } from '@/common/types';
import { namespace } from 'vuex-class';
import { randomId } from '@/common/bot/lib';
import {
  MAX_GUEST_FIELDS_CHAR,
  MIN_DESCRIPTION_CHAR_NUM,
} from '@/common/config';
import { UserInformation } from '@/common/api/models.pleased';
import { ConnectToAgent } from '@/common/bot/types';

const userModule = namespace('user');

interface TicketForm {
  name: string;
  email: string;
  description: string;
  phone: string;
}

@Component({
  components: {
    BottomWrapper,
  },
  directives: {
    waiting,
  },
})
export default class GuestForm extends Vue {
  @userModule.Mutation('updatePleasedUser') updatePleasedUser!: (
    payload: PleasedUserInfo
  ) => void;
  @Prop({ default: null }) readonly guestSavedData!: VisitorInfoFilled | null;
  @Prop() readonly connectConfig!: ConnectToAgent | null;

  loading = false;
  MAX_GUEST_FIELDS_CHAR = MAX_GUEST_FIELDS_CHAR;

  get isDescriptionExceed () {
    return this.form.description.length > MAX_GUEST_FIELDS_CHAR.description;
  }

  get showDescriptionBox () {
    return this.connectConfig?.showDescriptionBox ?? true;
  }

  get descriptionPlaceholder () {
    return this.connectConfig?.descriptionMessage || this.$t('global.describe');
  }

  get buttons () {
    return [
      {
        name: this.t('page.guest.button.proceed', 'Proceed'),
        id: '',
        isActive: true,
      },
    ];
  }
  form: TicketForm = {
    name: '',
    phone: '',
    email: '',
    description: '',
  };

  errors = {
    name: false,
    email: false,
    description: false,
    phone: false,
  };

  created () {
    if (this.guestSavedData) {
      this.form = {
        name: this.guestSavedData.visitorInfo.name || '',
        phone: this.guestSavedData.visitorInfo.phone || '',
        email: this.guestSavedData.visitorInfo.email || '',
        description: this.guestSavedData.description || '',
      };
    }
  }

  validate () {
    let result = true;
    if (!isPhoneValid(this.form.phone)) {
      this.errors.phone = true;
      result = false;
    }
    if (!isEmailValid(this.form.email)) {
      this.errors.email = true;
      result = false;
    }

    const textLength = this.form.description.length;
    if (this.connectConfig?.showDescriptionBox && (textLength < MIN_DESCRIPTION_CHAR_NUM || this.isDescriptionExceed)) {
      this.errors.description = true;
      result = false;
    }
    if (!this.form.name.length) {
      this.errors.name = true;
      result = false;
    }
    return result;
  }

  processGuestData (
    userData: Pick<UserInformation, 'id' | 'token' | 'foreignId'>
  ) {
    const { id, foreignId, token } = userData;

    this.updatePleasedUser({
      displayName: this.form.name || '',
      email: this.form.email || '',
      userId: id,
      foreignId: foreignId || '',
      phone: this.form.phone,
      token: token,
      isGuest: true,
    });

    const event: VisitorInfoFilled = {
      visitorInfo: {
        displayName: this.form.name,
        email: this.form.email,
        name: this.form.name,
        phone: this.form.phone,
        isGuest: true,
      },
      description: this.form.description,
      userData,
    };
    this.$emit('submit:detail', event);
  }

  handleSubmit () {
    if (!this.validate()) {
      return;
    }

    if (this.guestSavedData?.userData) {
      this.processGuestData(this.guestSavedData.userData);
      return;
    }

    this.loading = true;
    PleasedApi.getAnonymousToken()
      .then(res => {
        this.processGuestData(res);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
